import { colors } from '../../colors';
var input = {
  textColor: colors.lead
};
export default input;